import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const useAnimalDashboardTour = () => {
  const startTour = () => {
    const driverObj = driver({
      popoverClass: "driverjs-theme",
      showProgress: true,
      animate: true,
      smoothScroll: true,
      steps: [
        {
          element: "#dashboardLogo",
          popover: {
            title: "System Logo",
            description:
              "This is the Federal Republic of Nigeria National Flag and the" +
              " Sila Green Genetics organization Logo.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#dashboardHeader",
          popover: {
            title: "Dashboard Header",
            description:
              "This header provides navigation and context for the animal dashboard.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#statisticsCards",
          popover: {
            title: "Statistics Overview",
            description:
              "These cards show key animal statistics and metrics at a glance.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#animalTableCard",
          popover: {
            title: "Animal Data Table",
            description:
              "This table lists all animals in the system. Click a row to view detailed information about an animal.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#viewAnimalProfileButton",
          popover: {
            title: "View Animal Profile",
            description:
              "Click this button to access a very detailed profile of the selected animal, including all available data and history.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
      ],
    });
    setTimeout(() => driverObj.drive(), 500);
  };

  return { startTour };
};

const useAnimalDetailDashboardTour = () => {
  const startTour = () => {
    const driverObj = driver({
      showProgress: true,
      animate: true,
      smoothScroll: true,
      steps: [
        {
          element: "#animalDetailBack",
          popover: {
            title: "Back to Dashboard",
            description: "Click here to return to the main dashboard.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#animalDetailTitle",
          popover: {
            title: "Animal Name",
            description: "This is the name of the animal you are viewing.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#animalExportDropdown",
          popover: {
            title: "Export Data",
            description:
              "Export recipient evaluation or reproductive process data in CSV or Excel format.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#animalTabs",
          popover: {
            title: "Animal Details Tabs",
            description:
              "Switch between Overview, Metrics, and Images to see different aspects of the animal's data.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#animalOverviewInfo",
          popover: {
            title: "Animal Information",
            description:
              "See key details, growth metrics, and breeding information for this animal.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#animalImagesTab",
          popover: {
            title: "Animal Images",
            description: "Browse the photo gallery of this animal.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#GrowthMetrics",
          popover: {
            title: "Growth Metrics",
            description: "Animal Growth Metrics Data.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#breedingInfoCard",
          popover: {
            title: "Breeding Information",
            description: "View genealogy and breeding details for this animal.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#reproductiveProcessTable",
          popover: {
            title: "Reproductive Process",
            description:
              "See all reproductive process records and details for this animal.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#recipientEvaluationTable",
          popover: {
            title: "Recipient Evaluation",
            description:
              "Review all recipient evaluation data for this animal.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
        {
          element: "#physicalMeasurements",
          popover: {
            title: "Physical Measurements",
            description: "Animal Physical Measurements Data.",
            onNextClick: () => driverObj.moveNext(),
          },
        },
      ],
    });
    setTimeout(() => driverObj.drive(), 500);
  };

  return { startTour };
};

export { useAnimalDashboardTour, useAnimalDetailDashboardTour };
